import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

// Admin-editable site content (announcement bar, home hero, listing prices).
// Defaults mirror server/lib/siteContent.js so the page renders identically
// before the request returns or if it fails.
export const CONTENT_DEFAULTS = {
  announcement: { enabled: false, text: '', link: '', tone: 'info' },
  hero: {
    badge: 'Room in minutes. Not days.',
    title: 'Find a Room',
    highlight: 'Faster Than a Broker Picks Up',
    subtitle: 'Search → Contact owner directly → Move in. Zero brokerage. Zero waiting.',
  },
  pricing: {
    residential: { free: 5, price: 99 },
    commercial:  { free: 2, price: 499 },
  },
  plans: {
    trialDays: 60, starter: 499, growth: 999, pro: 1999,
    limits: {
      free:    { units: 5,   members: 1 },
      starter: { units: 20,  members: 2 },
      growth:  { units: 75,  members: 5 },
      pro:     { units: 200, members: 10 },
    },
  },
};

const SiteContentContext = createContext({ ...CONTENT_DEFAULTS, offers: [] });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({ ...CONTENT_DEFAULTS, offers: [] });

  // Live festive offers (public ones: no code needed). They start and end by
  // themselves, so check again every few minutes while the page is open.
  useEffect(() => {
    let cancelled = false;
    const load = () => axios.get('/api/plan/offers')
      .then(r => { if (!cancelled && r.data?.success) setContent(c => ({ ...c, offers: r.data.data || [] })); })
      .catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/content')
      .then(res => {
        if (cancelled || !res.data?.success) return;
        const d = res.data.data || {};
        setContent(c => ({
          offers: c.offers,
          announcement: { ...CONTENT_DEFAULTS.announcement, ...d.announcement },
          hero:         { ...CONTENT_DEFAULTS.hero, ...d.hero },
          pricing:      { ...CONTENT_DEFAULTS.pricing, ...d.pricing },
          plans:        { ...CONTENT_DEFAULTS.plans, ...d.plans, limits: { ...CONTENT_DEFAULTS.plans.limits, ...(d.plans?.limits || {}) } },
        }));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return <SiteContentContext.Provider value={content}>{children}</SiteContentContext.Provider>;
}

export const useSiteContent = () => useContext(SiteContentContext);
